import React from "react";
import BotonRegresar from "./shared/BotonRegresar";
import PayPalDonateButton  from "./shared/PaypalButton";

export default function Sumate({ onBack }) {
  return (
    <div className="row" style={{ marginBottom: "4rem" }}>
      <div
        className="card col l6 offset-l3"
        style={{ borderRadius: "20px", padding: "2rem" }}
      >
        {/* Logros */}
        
       

     {/* ¿Cómo puedes ayudar? (migrado desde Sumate) */}
<h5
  className="center-align"
  style={{ marginTop: "3rem", color: "#ef7cab", fontWeight: "600" }}
>
  ¿Cómo puedes ayudar?
</h5>
<p className="center-align">
  Puedes convertirte en voluntario, donador o embajador de nuestras
  campañas. Tu participación puede cambiar una vida... o muchas.
</p>
<div className="center">
  <button
  className="btn pink lighten-1 waves-effect waves-light"
  style={{
    borderRadius: "30px",
    fontWeight: "600",
    padding: "-0.5rem 2rem",
  }}
  onClick={() => {
    // Esta función viene de props, así que asegúrate que se le pase desde App.jsx
    if (typeof onBack === "function") onBack(); // Cierra Sumate
    setTimeout(() => {
      const evento = new CustomEvent("scrollToContacto");
      window.dispatchEvent(evento);
    }, 100);
  }}
>
  Quiero ayudar
</button>
  



<div>
<h5
    className="center-align"
    style={{ color: "#ef7cab", fontWeight: "600", marginBottom: "1rem" }}
  >
    Apóyanos con una donación (PayPal)
  </h5>      <PayPalDonateButton />
    </div>
  
  <h6 style={{fontWeight:"bolder"}}>
    En caso de requerir factura por su donativo, envienos su Comprobante del Donativo realizado y su constancia de situación fiscal al correo <a href="mailto:fundacionsoffy@gmail.com">fundacionsoffy@gmail.com</a>
  </h6>
</div>

<div
  style={{
    height: "1px",
    backgroundColor: "#ddd",
    margin: "2.5rem 0 2rem",
    width: "100%",
  }}
></div>

        {/* Empresas e instituciones aliadas */}
        <h5
          className="center-align"
          style={{ marginTop: "3rem", color: "#ef7cab", fontWeight: "600" }}
        >
          Nuestros Aliados
        </h5>
        <p style={{ textAlign: "justify" }}>
          En Fundación Soffy creemos en el poder de sumar voluntades, por eso 
          construimos alianzas con empresas e instituciones que desean ser parte
          activa del cambio social. A través de donativos en efectivo o especie o bien proyectos,
          estas organizaciones impulsan junto con nosotros programas de alto impacto en salud,
          educación y bienestar infantil.
        </p>
        <p style={{ textAlign: "justify" }}>
          Implementamos procesos claros y transparentes para asegurar que cada
          aportación llegue a quienes más lo necesitan, generando beneficios
          tangibles y sostenibles en nuestra comunidad.
        </p>
        <p
          className="center-align"
          style={{ fontWeight: "500", marginTop: "1rem" }}
        >
          ¿Representas a una empresa o institución?
          <br />
          <span className="grey-text text-darken-1">
            Contáctanos y construyamos juntos una historia de alto impacto social. 
          </span>
        </p>
{/* Logos de aliados divididos por categoría */}
<div className="row" style={{ marginTop: "2rem" }}>
  {/* Universidades */}
  <div className="col s12 m6 l12 center">
    <button
      className="btn waves-effect waves-light pink-text"
      style={{
        backgroundColor: "white",
        borderRadius: "30px",
        fontWeight: "600",
      }}
    >
      Universidades
    </button>
    <div className="logo-grid">
      {[
        "humanitas.png",
        "univ-londres.png",
        "anahuac.png",
        "itesm.png",
        "cuau.png",
        "uco.png",
        "uaq.jpg",
        "uteq.jpg",
      ].map((img, idx) => (
        <div key={idx} className="logo-wrapper">
          <img
            src={`assets/images/aliados/${img}`}
            alt={`universidad-${idx}`}
            className="responsive-img"
          />
        </div>
      ))}
    </div>
  </div>

  {/* Sector Público */}
  <div className="col s12 m6 l12 center">
    <button
      className="btn waves-effect waves-light pink-text"
      style={{
        backgroundColor: "white",
        borderRadius: "30px",
        fontWeight: "600",
      }}
    >
      Sector Público
    </button>
    <div className="logo-grid">
      {[
        "covca.png",
        "dif-queretaro.png",
        "dif-municipio.png",
        "secretaria-salud.png",
        "cetqro.png",
        "imss.png",
        "comunidar.png",
      ].map((img, idx) => (
        <div key={idx} className="logo-wrapper">
          <img
            src={`assets/images/aliados/${img}`}
            alt={`publico-${idx}`}
            className="responsive-img"
          />
        </div>
      ))}
    </div>
  </div>

  {/* Sector Privado */}
  <div className="col s12 m12 l12 center">
    <button
      className="btn waves-effect waves-light pink-text"
      style={{
        backgroundColor: "white",
        borderRadius: "30px",
        fontWeight: "600",
      }}
    >
      Sector Privado
    </button>

    <div className="logo-grid col l12 m12 s12">
      {[
        "asturiano.png",
        "chevrolet.png",
        "canaco.png",
        "fuchs.png",
        "santander.png",
        "heb.png",
        "maderas.png",
        "meura.png",
        "oxxo.png",
        "depot.png",
        "decor.jpg",
        "paper.jpg",
        "bticino.png",
        "ancestra.png",
        "suzuki.png",
        "kikolin.jpg"
      ].map((img, idx) => (
        <div key={idx} className="logo-wrapper">
          <img
            src={`assets/images/aliados/${img}`}
            alt={`privado-${idx}`}
            style={{borderRadius:"10px"}}
            className="responsive-img"
          />
        </div>
      ))}
    </div>
  </div>

  {/* Tercer Sector */}
  <div className="col s12 m12 l12 center">
    <button
      className="btn waves-effect waves-light pink-text"
      style={{
        backgroundColor: "white",
        borderRadius: "30px",
        fontWeight: "600",
      }}
    >
      Tercer Sector
    </button>

    <div className="logo-grid col l12 m12 s12">
      {[
        "estafeta.png",
        "merced.png",
        "monte.png", 
        "simi.png",
        "colegio-ingenieros.jpg",
        "colegio-arquitectos.png",
      ].map((img, idx) => (
        <div key={idx} className="logo-wrapper">
          <img
            src={`assets/images/aliados/${img}`}
            alt={`tercer-sector-${idx}`}
            className="responsive-img"
          />
        </div>
      ))}
    </div>
  </div>
</div>






        {/* Botón regresar */}
        <div className="center-align" style={{ marginBottom: "1.5rem" }}>
          <BotonRegresar onClick={onBack} />
        </div>
      </div>
    </div>
  );
}
